import { enUi } from "./game/locales/en-ui";
import { deUi } from "./game/locales/de-ui";

export type GameLanguage = "en" | "de";
const KEY = "massif_scrum_nebula_language";

export function loadLanguage(
  siteLanguage: string,
  read: () => string | null = () => localStorage.getItem(KEY)
): GameLanguage {
  try {
    const saved = read();
    if (saved === "en" || saved === "de") return saved;
  } catch {
    // The site's language still works when storage is unavailable.
  }
  return siteLanguage === "de" ? "de" : "en";
}

export function saveLanguage(
  language: GameLanguage,
  write: (_value: string) => void = (value) => localStorage.setItem(KEY, value)
) {
  try {
    write(language);
  } catch {
    // Keep the choice for this session when storage is unavailable.
  }
}

export type UiTextId = keyof typeof enUi;

export const uiText = (language: GameLanguage, id: UiTextId) =>
  (language === "de" ? deUi : enUi)[id];
